import { useMemoizedFn } from 'ahooks';
import { useQAPairConversationKnowledgeQuery, useSetQAPairMeta } from './useQAPair';
import { useClearKnowledgeQuery } from './useKnowledgeQuery';
import { useClearGlobalSelectedState } from './useMessageSelect';

export const useCleanQAPair = () => {
  const setQAPairMeta = useSetQAPairMeta();
  const clearGlobalSelectedState = useClearGlobalSelectedState();

  return useMemoizedFn(() => {
    setQAPairMeta({ visible: false, selectMode: 'single' });
    clearGlobalSelectedState();
  });
};

export const useAfterSubmitClearKnowledgeQuery = () => {
  const clearKnowledgeQuery = useClearKnowledgeQuery();
  const conversationKnowledgeQuery = useQAPairConversationKnowledgeQuery();

  return useMemoizedFn((submitQueryMsgIds: string[]) => {
    if (!conversationKnowledgeQuery) {
      return Promise.resolve();
    }

    const { knowledgeQuery, knowledgeReply } = conversationKnowledgeQuery;

    if (knowledgeQuery && submitQueryMsgIds.includes(knowledgeQuery.msgId)) {
      return clearKnowledgeQuery(conversationKnowledgeQuery.conversationId);
    }
    if (knowledgeReply && submitQueryMsgIds.includes(knowledgeReply.msgId)) {
      return clearKnowledgeQuery(conversationKnowledgeQuery.conversationId);
    }
    return Promise.resolve();
  });
};
